import DoctorCard from '../../components/DoctorCard';
import { formatUserName } from '../../utils/utils';

import { Icon, Text, Flex, Separator, Card, Button, Link, DateUtils, withStates } from '@amigoapp/doca-react';

const ContentWithStates = withStates(Flex);

const Home = ({ loading, date, user, onConsentTermClick, onCreateConsentTermClick }) => (
	<Flex align="center" className="doca-px-4" direction="col" flex={1} gap={4} justify="between">
		<Card className="doca-py-4 doca-px-8 doca-text--center doca-mt-8 telemedicine-card">
			<ContentWithStates align="center" direction="col" loading={loading}>
				<Flex gap={2} justify="center">
					<Icon name="video" />
					<Text align="center" as="h1" size="large">
						Teleatendimento
					</Text>
				</Flex>
				<Text className="doca-text--center doca-mt-2" size="small" variant="gray" weight="light">
					{DateUtils.format(date, { format: 'ddd, DD [de] MMMM [-] HH:mm[h]' })}
				</Text>
				<Separator className="doca-w-full" />
				<Text variant="gray" weight="light">
					Você está prestes a iniciar seu teleatendimento com {formatUserName(user.title, user.name)}.
					<br />
					Aceite os termos abaixo para prosseguir.
				</Text>
				<DoctorCard
					avatar={user.file?.thumb_url}
					className="doca-m-8"
					councilName={user.council_name}
					councilNumber={user.council_number}
					name={user.name}
					specialty={user.specialty}
					title={user.title}
				/>
				<Text className="doca-mb-6" variant="gray" weight="light">
					Ao clicar em prosseguir abaixo, eu aceito o<br />
					<Link href="#" target="" onClick={onConsentTermClick}>
						Termo de Uso e Consentimento.
					</Link>
				</Text>
				<Button variant="primary" onClick={onCreateConsentTermClick}>Prosseguir</Button>
			</ContentWithStates>
		</Card>
		<img alt="Amigo - Logo" className="doca-w-32 doca-mb-8" src="https://cdn.amigotech.com.br/logos/amigo.svg" />
	</Flex>
);

export default Home;
